import axios from 'axios';

// Note: baseURL is NOT set here because services already include backEnd.url in their calls
const api = axios.create({});

export default api;
